import { supabase } from '../lib/supabaseClient';
import { documentoACorreo } from '../domain/loginIdentity';
import type { PerfilRecurso } from '../domain/types';

/**
 * ⚠️ NUNCA `select('*')` sobre `profiles`: las columnas bancarias estan revocadas incluso
 * para el admin y la consulta entera falla con 42501. Se piden columnas explicitas.
 */
const COLUMNAS_PERFIL = 'id, dni, first_names, last_names, roles, status';

interface FilaPerfil {
  id: string;
  dni: string;
  first_names: string | null;
  last_names: string | null;
  roles: string[] | null;
  status: string | null;
}

function aPerfil(fila: FilaPerfil): PerfilRecurso {
  const nombres = fila.first_names ?? '';
  const apellidos = fila.last_names ?? '';
  const iniciales = `${nombres.trim()[0] ?? ''}${apellidos.trim()[0] ?? ''}`.toUpperCase();
  return {
    id: fila.id,
    dni: fila.dni,
    nombres,
    apellidos,
    iniciales: iniciales || '··',
    roles: fila.roles ?? [],
  };
}

export async function iniciarSesion(documento: string, clave: string): Promise<PerfilRecurso> {
  const email = documentoACorreo(documento);
  const { error } = await supabase.auth.signInWithPassword({ email, password: clave });

  // El mensaje real de Supabase ("Invalid login credentials") no le dice nada a nadie en campo.
  if (error) throw new Error('Documento o clave incorrectos.');

  const perfil = await obtenerPerfilActual();
  if (!perfil) {
    // Sesion valida pero sin ficha: la cuenta existe y no sirve para nada. Se cierra para
    // no dejar a la persona en un limbo donde parece que entro pero no ve nada.
    await cerrarSesion();
    throw new Error('Tu cuenta existe pero no tiene ficha de trabajador. Avisa a tu coordinador.');
  }
  return perfil;
}

export async function obtenerPerfilActual(): Promise<PerfilRecurso | null> {
  const { data: sesion } = await supabase.auth.getSession();
  if (!sesion.session) return null;

  const { data, error } = await supabase
    .from('profiles')
    .select(COLUMNAS_PERFIL)
    .eq('id', sesion.session.user.id)
    .maybeSingle();

  if (error || !data) return null;
  return aPerfil(data as FilaPerfil);
}

export async function cerrarSesion(): Promise<void> {
  await supabase.auth.signOut();
}
